import { useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export default function Support() {
  const { user } = useAuth();
  const [form, setForm] = useState({ subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", { name: user?.name, email: user?.email, subject: form.subject, message: form.message });
      toast.success("Message envoyé au support.");
      setForm({ subject: "", message: "" });
    } catch (err) { toast.error(apiError(err)); } finally { setLoading(false); }
  };
  return (
    <div>
      <h2 className="font-heading text-2xl text-ink mb-5">Contacter le support</h2>
      <form onSubmit={submit} className="bg-cream border border-line rounded-lg p-6 space-y-4 max-w-lg">
        <div><Label htmlFor="subject">Sujet</Label><Input id="subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} required className="bg-sand border-line mt-1" data-testid="support-subject" /></div>
        <div><Label htmlFor="message">Message</Label><Textarea id="message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} required rows={5} className="bg-sand border-line mt-1" data-testid="support-message" /></div>
        <Button type="submit" disabled={loading} className="bg-terracotta hover:bg-terracotta-dark text-white" data-testid="support-submit">{loading ? "Envoi…" : "Envoyer"}</Button>
      </form>
    </div>
  );
}
